<app-frontend-header i18n-header header="Skillz Team">
  <a routerLink="/" i18n>Home</a>
  <a routerLink="#" i18n>Skillz Team</a>
</app-frontend-header>

<section class="my-20 px-4">
  <div class="mx-auto max-w-screen-lg px-4 sm:px-12">
    <app-section-header
      i18n-description
      description="Skillz vzw, once started as a duo, now a real team! A group of diverse
    people with a common passion: inspiring the next generation of
    inventors, artists and gamers."
    />

    <div class="flex flex-col items-center mb-8">
      <p class="text-center text-2xl text-slate-700 max-w-3xl font-light" i18n>
        Do you want to know who we are and what we do? Discover it here!
      </p>
    </div>
  </div>
</section>

<section class="my-20">
  <div class="m-auto max-w-screen-lg px-4 sm:px-12">
    <div class="grid sm:grid-cols-3 gap-8">
      @for (teamMember of teamMembers(); track teamMember.name) {
        <app-skillz-team-card [teamMember]="teamMember"></app-skillz-team-card>
      }
    </div>
  </div>
</section>

<section class="my-20 px-4">
  <div class="mx-auto max-w-screen-lg px-4 sm:px-12">
    <div class="text-slate-600 flex items-center justify-center mt-16 gap-4">
      <h2 class="inline text-xl mb-2" i18n>Would you like to contact us?</h2>
      <a
        i18n-routerLink="@@//contact-us"
        routerLink="/contact-us"
        class="button text-sm cursor-pointer"
      >
        <span i18n>Contact us</span>
      </a>
    </div>
  </div>
</section>
